<template>
    <div
        class="modal items-center"
        :class="{'modal-open':visiblePopup}"
    >
        <!-- <button
            class="input-base input-calendar"
            @click="visiblePopup=true"
            v-text="userDate"
        /> -->
        <div v-if="visiblePopup">
            <div class="card w-full max-w-[20rem] shadow bg-white ">
                <div class=" px-4 pt-3 pb-2 min-w-full xxs:min-w-[20rem] overflow-auto">
                    <div class="flex flex-wrap xxs:flex-nowrap xxs:justify-between items-baseline px-2.5">
                        <!-- 左箭頭 -->
                        <button
                            class="btn btn-circle btn-ghost border-0 -ml-4 order-1"
                            @click="back"
                        >
                            <SvgIcon
                                icon-name="arrow_back"
                                class="text-gray-900 w-3.5 h-3.5"
                            />
                        </button>
                        <h3 class="btn btn-text border-0 bg-white text-[21px] text-center text-gray-900 font-bold xxs:order-2 order-3">
                            <div
                                v-if="templateShow===templateList.d"
                                class="flex text-primary"
                                @click="changeTemplate(templateList.y)"
                            >
                                {{ `民國${showROCtext(selectedDateList.year)}年${selectedDateList.month+1}月` }}
                                <SvgIcon
                                    icon-name="edit"
                                    class="text-white w-6 h-6"
                                />
                            </div>
                            <span
                                v-else-if="templateShow===templateList.m"
                                @click="changeTemplate(templateList.y)"
                            >
                                {{ `民國${showROCtext(selectedDateList.year)}年` }}
                            </span>
                            <span v-else-if="templateShow===templateList.y">
                                {{ `民國${showROCtext(yearList[0])}-${showROCtext(yearList[19])}年` }}
                            </span>
                        </h3>
                        <!-- 右箭頭 -->
                        <button
                            class="btn btn-circle btn-ghost border-0 xxs:-mr-4 xxs:order-3 order-2"
                            @click="next"
                        >
                            <SvgIcon
                                icon-name="arrow_forward"
                                class="text-gray-900 w-3.5 h-3.5"
                            />
                        </button>
                    </div>
                    <!-- 日曆列表 -->
                    <template v-if="templateShow===templateList.d">
                        <ul class="grid grid-cols-7 auto-cols-[2.5rem] gap-0 auto-rows-[2.5rem]">
                            <li
                                v-for="(weekday , index) in weekList"
                                :key="index"
                                class="text-gray-400 text-xs flex items-center justify-center"
                            >
                                {{ weekday }}
                            </li>
                            <li
                                v-for="(item ,i) in monthDayList"
                                :key="i"
                                class="flex items-center"
                            >
                                <button
                                    class="w-full p-1 rounded-full text-[13px] font-bold h-full"
                                    :class="[
                                        (item&&betweenDay(item))&&'hover:bg-blue-100 cursor-pointer',
                                        (hasTodayButton&&today===item)&&'ring ring-primary ring-offset-1',
                                        (item&&!betweenDay(item))&&'text-gray-200 bg-transparent',
                                        activeDate===item&&'bg-primary text-white'
                                    ]"
                                    @click="betweenDay(item) ? setDay(new Date(item).getDate()):''"
                                >
                                    {{ item ? new Date(item).getDate():'' }}
                                </button>
                            </li>
                        </ul>
                    </template>
                    <!-- 月份列表 -->
                    <template v-else-if="templateShow===templateList.m">
                        <ul class="grid grid-cols-4 gap-1 min-h-[14rem] auto-rows-[2.5rem] grid-rows-3">
                            <li
                                v-for="(month , index) in monthList"
                                :key="index"
                                class="flex items-center h-full"
                            >
                                <button
                                    class="w-full btn border-0 btn-sm min-w-[3.25rem] text-[13px] font-bold rounded-full bg-transparent"
                                    :class="[
                                        !betweenDay(month)&& 'text-gray-200',
                                        betweenDay(month)&&'hover:bg-blue-100 text-gray-900',
                                        (userDateFormat.y === selectedDateList.year&&userDateFormat.m=== month)&&'text-primary'
                                    ]"
                                    :disabled="!betweenDay(month)"
                                    @click="betweenDay(month)?setMonth(month):''"
                                >
                                    {{ month+1 }}月
                                </button>
                            </li>
                        </ul>
                    </template>
                    <!-- 年份列表 -->
                    <template v-else-if="templateShow===templateList.y">
                        <ul class="grid grid-cols-4 xxs:grid-cols-5 gap-2 min-h-[14rem] auto-rows-[3rem] grid-rows-4">
                            <li
                                v-for="(year , index) in yearList"
                                :key="index"
                                class="flex items-center justify-center h-full w-full"
                            >
                                <button
                                    class="btn border-0 btn-sm min-w-[3rem] text-[13px] font-bold rounded-full p-0 w-auto bg-transparent"
                                    :class="[
                                        !betweenDay(year)&&'text-gray-200',
                                        betweenDay(year)&&'text-gray-900 hover:bg-blue-100',
                                        (userDateFormat.y === year)&&'text-primary'
                                    ]"
                                    :disabled="!betweenDay(year)"
                                    @click="betweenDay(year)?setYear(year):''"
                                >
                                    {{ showROCtext(year) }}
                                </button>
                            </li>
                        </ul>
                    </template>
                    <div class="flex justify-between items-baseline border-t border-solid mt-2.5 pt-1.5">
                        <div>
                            <button
                                v-if="hasTodayButton"
                                class="btn-sm btn-text text-sm font-bold text-left"
                                @click="setDate()"
                                v-text="'今日'"
                            />
                        </div>
                        <button
                            class="btn-sm btn-text text-sm font-bold text-right"
                            @click="handleClose"
                            v-text="'取消'"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, computed, toRefs, watch } from 'vue';

export default {
    props: {
        userDate: {
            type: String,
            default: '',
        },
        // userDate是民國年嗎
        isYearROC: {
            type: Boolean,
            default: false
        },
        visiblePopup: {
            type: Boolean,
            default: true
        },
        // 需要顯示今日按鈕嗎?
        hasTodayButton: {
            type: Boolean,
            default: false
        },
        maxDate: {
            type: String,
            default: '',
        },
        minDate: {
            type: String,
            default: '',
        }
    },
    emits: ['update:userDate', 'update:visiblePopup'],
    setup(props, { emit }) {
        const { userDate, isYearROC, maxDate, minDate, visiblePopup } = toRefs(props);

        const activeDate = ref('');
        const templateList = reactive({
            d: 'day',
            m: 'month',
            y: 'year',
        });
        const templateShow = ref('day');
        const selectedDateList = reactive({
            year: '', month: '', day: '',
        });
        const weekList = ['日', '一', '二', '三', '四', '五', '六'];
        const monthList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

        // 小於10補0
        const padStart2 = (num) => {
            return String(num).padStart(2, '0');
        };

        // 格式化日期
        const formatDate = (d) => {
            return {
                y: !d ? new Date().getFullYear() : new Date(d).getFullYear(),
                m: !d ? new Date().getMonth() : new Date(d).getMonth(),
                d: !d ? new Date().getDate() : new Date(d).getDate()
            };
        };
        // 民國年轉換成西元年
        const changeROCtoAD = (d) => {
            const dateList = d.split('/');
            if (dateList[0].includes('元')) {
                dateList[0] = 1912;
            } else if (dateList[0].includes('前')) {
                const y = dateList[0].split('前');
                dateList[0] = 1912 - Number(y[1]);
            } else {
                dateList[0] = Number(dateList[0]) + 1911;
            }
            return dateList.join('/');
        };

        // 西元年轉民國年
        const showROCtext = (year) => {
            const rocYear = year - 1911;
            if (rocYear === 1) {
                return '元';
            } else if (rocYear < 1) {
                return `前${rocYear * -1 + 1}`;
            } else {
                return rocYear;
            }
        };

        // 最大日期變成物件 {y:2022,m:12,d:1, millisecond: 毫秒, yearAtleast: 年列表的最大結束年}
        let maxDateList = reactive({});
        // 最小日期變成物件 {y:2022,m:12,d:1}
        let minDateList = reactive({});

        /**
         * 轉成毫秒
         * @param {String} 日期'2022/2/22'
         * @return {Number}  毫秒
         */
        const toMillisecond = (d) => {
            return Date.parse(new Date(d));
        };

        /**
         * 驗證日期是否可以選擇，不能選擇的畫面disabled
         * @param {String} 依照templateShow.value可能傳入 日期: yyyy/mm/dd， 月: m ，年: y
         * @return {Boolean}  true=可以選之日期
         */
        const betweenDay = (d) => {
            switch (templateShow.value) {
                case templateList.y: {
                    return d <= maxDateList.y && d >= minDateList.y;
                }
                case templateList.m: {
                    return toMillisecond(`${selectedDateList.year}/${d + 1}/1`) <= maxDateList.millisecond &&
                        toMillisecond(`${selectedDateList.year}/${d + 1}/${monthDays.value}`) >= minDateList.millisecond;
                }
                case templateList.d: {
                    const dayMillisecond = toMillisecond(d);
                    return (dayMillisecond <= maxDateList.millisecond &&
                        dayMillisecond >= minDateList.millisecond);
                }
                default: return true;
            }
        };

        // 取得今日日曆日期
        const today = computed(() => {
            const { y, m, d } = formatDate();
            return `${y}/${padStart2(m + 1)}/${padStart2(d)}`;
        });

        // 取得今日日曆日期
        const userDateFormat = computed(() => {
            let list = {};
            if (userDate.value && isYearROC.value) {
                const d = changeROCtoAD(userDate.value);
                list = formatDate(d);
            } else {
                list = formatDate(userDate.value);
            }
            return list;
        });

        /**
         * 西元年/民國年的顯示方式
         * @return {Object} {AD西元日期/ROC民國日期}
         */
        const selectDate = computed(() => {
            const { year, month, day } = selectedDateList;
            const mm = padStart2(month + 1);
            const dd = padStart2(day);
            return {
                AD: `${year}/${mm}/${dd}`,
                ROC: `${showROCtext(year)}/${mm}/${dd}`,
            };
        });

        // 當月有幾天
        const monthDays = computed(() => new Date(selectedDateList.year, selectedDateList.month + 1, 0).getDate());

        /**
         * 日子: 顯示用的日曆日期
         * @return {Array.String}  ['y/m+1/d','y/m+1/d']
         */
        const monthDayList = computed(() => {
            const days = [];
            const { year, month } = selectedDateList;
            const mm = padStart2(month + 1);
            for (let i = 1; i <= monthDays.value; i++) {
                days.push(`${year}/${mm}/${padStart2(i)}`);
            }
            const startWeekDay = new Date(year, month, 1).getDay();
            if (startWeekDay !== 0) {
                for (let i = 0; i <= startWeekDay - 1; i++) {
                    days.unshift('');
                }
            }
            return days;
        });

        // 顯示選擇的年月日清單
        const changeTemplate = (type) => {
            templateShow.value = type;
        };

        // 設定選取日期
        const setDate = (list) => {
            if (!list) {
                list = formatDate();
                changeTemplate(templateList.d);
            }
            selectedDateList.day = list.d;
            selectedDateList.month = list.m;
            selectedDateList.year = list.y;
        };

        const setDay = (d) => {
            selectedDateList.day = d;
            emit('update:userDate', isYearROC.value ? selectDate.value.ROC : selectDate.value.AD);
            handleClose();
        };

        const setMonth = (m) => {
            selectedDateList.month = m;
            changeTemplate(templateList.d);
        };

        const setYear = (y) => {
            selectedDateList.year = y;
            changeTemplate(templateList.m);
        };

        // 年份清單
        const yearList = computed(() => {
            // 製作清單
            const list = [];
            const startYear = Math.floor((selectedDateList.year - 1 - 1911) / 20) * 20 + 1911;
            for (let i = 1; i <= 20; i++) {
                list.push(startYear + i);
            }
            return list || [];
        });

        // 上一個的年?月?日?
        const back = () => {
            const { year, month } = selectedDateList;
            switch (templateShow.value) {
                case templateList.y: {
                    const yearLimit = Math.floor((year - 1911) / 20) * 20 + 1 + 1911;
                    if (yearLimit > minDateList.y) {
                        selectedDateList.year -= 20;
                    }
                    break;
                }
                case templateList.m: {
                    if (year > minDateList.y) {
                        selectedDateList.year -= 1;
                    }
                    break;
                }
                case templateList.d: {
                    const dayMillisecond = toMillisecond(`${year}/${month + 1}/1`);
                    if (dayMillisecond <= maxDateList.millisecond && dayMillisecond >= minDateList.millisecond) {
                        selectedDateList.month = month === 0 ? 11 : month - 1;
                        if (selectedDateList.month === 11) {
                            selectedDateList.year -= 1;
                        }
                    }
                    break;
                }
            };
        };

        // 下一個的年?月?日?
        const next = () => {
            const { year, month } = selectedDateList;
            switch (templateShow.value) {
                case templateList.y: {
                    if (year + 20 < maxDateList.yearListEnd) {
                        selectedDateList.year += 20;
                    }
                    break;
                }
                case templateList.m: {
                    if (year <= maxDateList.y) {
                        selectedDateList.year += 1;
                    }
                    break;
                }
                case templateList.d: {
                    const dayMillisecond = toMillisecond(`${year}/${month + 1}/${monthDays.value}`);
                    if (dayMillisecond <= maxDateList.millisecond && dayMillisecond >= minDateList.millisecond) {
                        selectedDateList.month = month === 11 ? 0 : month + 1;
                        if (selectedDateList.month === 0) {
                            selectedDateList.year += 1;
                        }
                    }
                    break;
                }
            };
        };

        const handleClose = () => {
            emit('update:visiblePopup', false);
        };

        watch(() => visiblePopup.value, (nV) => {
            if (nV) {
                changeTemplate(templateList.d);
                setDate(userDateFormat.value);
                activeDate.value = selectDate.value.AD;
            }
        }, { immediate: true });

        // 最小日期
        watch(() => minDate.value, (nV) => {
            let minDateAD = '';
            if (nV) {
                minDateAD = isYearROC.value ? changeROCtoAD(nV) : nV;
            } else {
                const { y, m, d } = formatDate();
                minDateAD = `${y - 120}/${m + 1}/${d}`;
            }
            minDateList = {
                ...formatDate(minDateAD),
                millisecond: toMillisecond(minDateAD),
            };
        }, { immediate: true });

        // 最大日期
        watch(() => maxDate.value, (nV) => {
            let maxDateAD = '';
            if (nV) {
                maxDateAD = isYearROC.value ? changeROCtoAD(nV) : nV;
            } else {
                const { y, m, d } = formatDate();
                maxDateAD = `${y + 120}/${m + 1}/${d}`;
            }
            maxDateList = {
                ...formatDate(maxDateAD),
                millisecond: toMillisecond(maxDateAD),
            };
            maxDateList.yearListEnd = Math.ceil((maxDateList.y - 1911) / 20) * 20 + 1911;
        }, { immediate: true });

        return {
            weekList,
            monthList,
            selectedDateList,
            monthDayList,
            yearList,
            templateList,
            templateShow,
            activeDate,
            userDateFormat,
            today,
            showROCtext,
            next,
            back,
            changeTemplate,
            setMonth,
            setDay,
            setYear,
            setDate,
            handleClose,
            betweenDay
        };
    },
};
</script>
